package org.matthewo.table.games

import org.matthewo.api.*
import org.matthewo.schema.MetricsMeta
import org.matthewo.styles.color
import org.matthewo.table.RecordsTable
import org.matthewo.table.RecordsTableProps
import react.ChildrenBuilder

@Suppress("UNCHECKED_CAST", "FUNCTIONNAME")
fun <M : MetricsAPI<Short>> ChildrenBuilder.RecordsTableGeneric(year: Int?, competitions: List<EventCompetition<Short, M?>>?, props: RecordsTableProps<Short, *>.() -> Unit = {}) {
    when (year) {
        2021 -> RecordsTableFreightFrenzy {
            records = competitions as List<EventCompetition<Short, MetricsFreightFrenzyAPI<Short>?>>?
            props()
        }
        
        2022 -> RecordsTablePowerPlay {
            records = competitions as List<EventCompetition<Short, MetricsPowerPlayAPI<Short>?>>?
            props()
        }
        
        2023 -> RecordsTableCenterStage {
            records = competitions as List<EventCompetition<Short, MetricsCenterStageAPI<Short>?>>?
            props()
        }
        
        2024 -> RecordsTableIntoTheDeep {
            records = competitions as List<EventCompetition<Short, MetricsIntoTheDeepAPI<Short>?>>?
            props()
        }
        
        2025 -> RecordsTableDecode {
            records = competitions as List<EventCompetition<Short, MetricsDecodeAPI<Short>?>>?
            props()
        }
        
        2026 -> RecordsTableBioBuzz {
            records = competitions as List<EventCompetition<Short, MetricsBioBuzzAPI<Short>?>>?
            props()
        }
        
        102021 -> RecordsTableFreightFrenzyCRI {
            records = competitions as List<EventCompetition<Short, MetricsFreightFrenzyCRIAPI<Short>?>>?
            props()
        }
        
        102022 -> RecordsTablePowerPlayCRI {
            records = competitions as List<EventCompetition<Short, MetricsPowerPlayCRIAPI<Short>?>>?
            props()
        }
        
        102023 -> RecordsTableCenterStageCRI {
            records = competitions as List<EventCompetition<Short, MetricsCenterStageCRIAPI<Short>?>>?
            props()
        }
        
        102024 -> RecordsTableIntoTheDeepCRI {
            records = competitions as List<EventCompetition<Short, MetricsIntoTheDeepCRIAPI<Short>?>>?
            props()
        }
        
        else -> Unit
    }
}
